module.exports = __webpack_public_path__ + "img/header-navigation-below-toyota.0fffebe2.png";